var _path, _path2, _circle;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgLinkedin = function SvgLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.667 1h-18a3 3 0 0 0-3 3v18a3 3 0 0 0 3 3h18a3 3 0 0 0 3-3V4a3 3 0 0 0-3-3ZM6.667 11.5V19M12.667 19v-7.5",
    stroke: "#00412F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.667 19v-4.5a3 3 0 0 0-6 0",
    stroke: "#00412F"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6.667,
    cy: 9.278,
    r: 0.75,
    fill: "#00412F"
  })));
};

export { SvgLinkedin as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjYiIGhlaWdodD0iMjYiIHZpZXdCb3g9IjAgMCAyNiAyNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIxLjY2NyAxSDMuNjY2OTlDMi4wMTAxNCAxIDAuNjY2OTkyIDIuMzQzMTUgMC42NjY5OTIgNFYyMkMwLjY2Njk5MiAyMy42NTY5IDIuMDEwMTQgMjUgMy42NjY5OSAyNUgyMS42NjdDMjMuMzIzOCAyNSAyNC42NjcgMjMuNjU2OSAyNC42NjcgMjJWNEMyNC42NjcgMi4zNDMxNSAyMy4zMjM4IDEgMjEuNjY3IDFaIiBzdHJva2U9IiMwMDQxMkYiLz4KPHBhdGggZD0iTTYuNjY2OTkgMTEuNVYxOSIgc3Ryb2tlPSIjMDA0MTJGIi8+CjxwYXRoIGQ9Ik0xMi42NjcgMTlWMTEuNSIgc3Ryb2tlPSIjMDA0MTJGIi8+CjxwYXRoIGQ9Ik0xOC42NjcgMTlWMTQuNUMxOC42NjcgMTMuNzA0NCAxOC4zNTA5IDEyLjk0MTMgMTcuNzg4MyAxMi4zNzg3QzE3LjIyNTcgMTEuODE2MSAxNi40NjI2IDExLjUgMTUuNjY3IDExLjVDMTQuODcxMyAxMS41IDE0LjEwODMgMTEuODE2MSAxMy41NDU3IDEyLjM3ODdDMTIuOTgzMSAxMi45NDEzIDEyLjY2NyAxMy43MDQ0IDEyLjY2NyAxNC41IiBzdHJva2U9IiMwMDQxMkYiLz4KPGNpcmNsZSBjeD0iNi42NjY5OSIgY3k9IjkuMjc4MzIiIHI9IjAuNzUiIGZpbGw9IiMwMDQxMkYiLz4KPC9zdmc+Cg==";